import type { AuditLogsState } from "./types";

export const initialState: AuditLogsState = {
  requestsInProgress: 0,
  absenceAuditLogs: {
    content: [],
    pagination: {
      sort: { orders: [] },
      pageNumber: 0,
      pageSize: 0,
      offset: 0,
    },
    totalElements: 0,
  },
  notificationAuditLogs: {
    content: [],
    pagination: {
      sort: { orders: [] },
      pageNumber: 0,
      pageSize: 0,
      offset: 0,
    },
    totalElements: 0,
  },
  isLoading: false,
};

export default initialState;
